module.exports = __webpack_public_path__ + "static/media/badminton.662b0308.jpg";